import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { CrashLogger } from '../../app/logger';
import * as Actions from '../../redux/actions';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
        }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        const crashPayload = {
            stack_trace: errorInfo.componentStack,
            error_stack: error.stack,
            current_window: this.props.history.location.pathname,
            search: this.props.history.location.search,
            benefit: JSON.stringify(this.props.benefit),
            cart: JSON.stringify(this.props.cart),
        };

        CrashLogger.push(crashPayload);
        this.props.dispatch(Actions.reactCrashLog(crashPayload));
    }

    render() {

        if (this.state.hasError) {
            return this.props.fallback_ui;
        }

        return this.props.children;
    }
}


const mapStateToProps = (store) => {
    return {
        benefit: store.data.BenefitPage,
        cart: store.config.Cart,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch,
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, null)(ErrorBoundary));
